var chunkMapping = {
	"100": [
		1100
	],
	"252": [
		1252
	],
	"276": [
		3276
	],
	"284": [
		5284
	],
	"292": [
		9292
	],
	"330": [
		4330
	],
	"412": [
		6412
	],
	"420": [
		6420
	],
	"548": [
		9548
	],
	"550": [
		3550
	],
	"562": [
		2562
	],
	"614": [
		1614
	],
	"698": [
		9698
	],
	"740": [
		740
	],
	"762": [
		6762
	],
	"815": [
		6815
	],
	"818": [
		8818
	],
	"880": [
		9880
	]
};
var idToExternalAndNameMapping = {
	"740": [
		"default",
		"./FixitTool",
		9055
	],
	"1100": [
		"default",
		"./InSeasonWeb",
		979
	],
	"1252": [
		"default",
		"./Settings",
		8359
	],
	"1614": [
		"default",
		"./TccReportsPlugin",
		8279
	],
	"2562": [
		"default",
		"./VariableRate",
		1447
	],
	"3276": [
		"default",
		"./DmbWeb",
		1793
	],
	"3550": [
		"default",
		"./DataInboxWeb",
		6055
	],
	"4330": [
		"default",
		"./ProgramsPlugin",
		1967
	],
	"5284": [
		"default",
		"./AppsMarketplacePlugin",
		3807
	],
	"6412": [
		"default",
		"./DataHub",
		6544
	],
	"6420": [
		"default",
		"./ArdExport",
		2836
	],
	"6762": [
		"default",
		"./TccScriptCreatorPlugin",
		3505
	],
	"6815": [
		"default",
		"./FieldSelectionPlugin",
		995
	],
	"8818": [
		"default",
		"./OperationHub",
		1225
	],
	"9292": [
		"default",
		"./CropPlanning",
		4174
	],
	"9548": [
		"default",
		"./InformationArchitecture",
		7418
	],
	"9698": [
		"default",
		"./SeasonReportsWeb",
		4507
	],
	"9880": [
		"default",
		"./Dashboard",
		7535
	]
};
var idToRemoteMap = {
	"740": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"1100": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"1252": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"1614": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"2562": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"3276": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"3550": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"4330": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"5284": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"6412": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"6420": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"6762": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"6815": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"8818": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"9292": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"9548": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"9698": [
		{
			"externalType": "promise",
			"name": ""
		}
	],
	"9880": [
		{
			"externalType": "promise",
			"name": ""
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"740": {
		"shareScope": "default",
		"name": "./FixitTool",
		"externalModuleId": 9055,
		"remoteName": ""
	},
	"1100": {
		"shareScope": "default",
		"name": "./InSeasonWeb",
		"externalModuleId": 979,
		"remoteName": ""
	},
	"1252": {
		"shareScope": "default",
		"name": "./Settings",
		"externalModuleId": 8359,
		"remoteName": ""
	},
	"1614": {
		"shareScope": "default",
		"name": "./TccReportsPlugin",
		"externalModuleId": 8279,
		"remoteName": ""
	},
	"2562": {
		"shareScope": "default",
		"name": "./VariableRate",
		"externalModuleId": 1447,
		"remoteName": ""
	},
	"3276": {
		"shareScope": "default",
		"name": "./DmbWeb",
		"externalModuleId": 1793,
		"remoteName": ""
	},
	"3550": {
		"shareScope": "default",
		"name": "./DataInboxWeb",
		"externalModuleId": 6055,
		"remoteName": ""
	},
	"4330": {
		"shareScope": "default",
		"name": "./ProgramsPlugin",
		"externalModuleId": 1967,
		"remoteName": ""
	},
	"5284": {
		"shareScope": "default",
		"name": "./AppsMarketplacePlugin",
		"externalModuleId": 3807,
		"remoteName": ""
	},
	"6412": {
		"shareScope": "default",
		"name": "./DataHub",
		"externalModuleId": 6544,
		"remoteName": ""
	},
	"6420": {
		"shareScope": "default",
		"name": "./ArdExport",
		"externalModuleId": 2836,
		"remoteName": ""
	},
	"6762": {
		"shareScope": "default",
		"name": "./TccScriptCreatorPlugin",
		"externalModuleId": 3505,
		"remoteName": ""
	},
	"6815": {
		"shareScope": "default",
		"name": "./FieldSelectionPlugin",
		"externalModuleId": 995,
		"remoteName": ""
	},
	"8818": {
		"shareScope": "default",
		"name": "./OperationHub",
		"externalModuleId": 1225,
		"remoteName": ""
	},
	"9292": {
		"shareScope": "default",
		"name": "./CropPlanning",
		"externalModuleId": 4174,
		"remoteName": ""
	},
	"9548": {
		"shareScope": "default",
		"name": "./InformationArchitecture",
		"externalModuleId": 7418,
		"remoteName": ""
	},
	"9698": {
		"shareScope": "default",
		"name": "./SeasonReportsWeb",
		"externalModuleId": 4507,
		"remoteName": ""
	},
	"9880": {
		"shareScope": "default",
		"name": "./Dashboard",
		"externalModuleId": 7535,
		"remoteName": ""
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}